import { FC } from 'react';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
} from 'react-router-dom';

import { LoginScreen } from '../screens/login.screen';
import { SignupScreen } from '../screens/signup.screen';
import { OnBoardingScreen, AboutYouScreen } from '../screens/onboarding';
import { ResetPasswordScreen, ConfirmPasswordScreen } from '../screens/reset-password';

import { PublicRoute } from './public.router';
import { PrivateRoute } from './private.router';
import { DashboardRouter } from './dashboard.router';

import { Layout } from '../components/Layout';

const AppRouter: FC = () => (
    <Router>
        <Routes>
            <Route
                path="/login"
                element={(
                    <PublicRoute>
                        <LoginScreen />
                    </PublicRoute>
                )}
            />
            <Route
                path="/reset-password"
                element={(
                    <PublicRoute>
                        <ResetPasswordScreen />
                    </PublicRoute>
                )}
            />
            <Route
                path="/confirm-password"
                element={(<ConfirmPasswordScreen />)}
            />
            <Route
                path="/signup"
                element={(
                    <PublicRoute>
                        <SignupScreen />
                    </PublicRoute>
                )}
            />
            <Route
                path="/about-you"
                element={(
                    <PrivateRoute>
                        <AboutYouScreen />
                    </PrivateRoute>
                )}
            />
            <Route
                path="/onboarding"
                element={(
                    <Navigate to="/onboarding/start" />
                )}
            />
            <Route
                path="/onboarding/*"
                element={(
                    <PrivateRoute>
                        <OnBoardingScreen />
                    </PrivateRoute>
                )}
            />
            <Route
                path="/*"
                element={(
                    <PrivateRoute>
                        <Layout>
                            <DashboardRouter />
                        </Layout>
                    </PrivateRoute>
                )}
            />
        </Routes>
    </Router>
);

export { AppRouter };
